var map = {
	"./aia.svg": 1402,
	"./ant.svg": 1403,
	"./aus.svg": 1404,
	"./bah.svg": 1405,
	"./ban.svg": 1406,
	"./bar.svg": 1407,
	"./ber.svg": 1408,
	"./biz.svg": 1409,
	"./bot.svg": 1410,
	"./bru.svg": 1411,
	"./can.svg": 1412,
	"./cay.svg": 1413,
	"./cmr.svg": 1414,
	"./cok.svg": 1415,
	"./cyp.svg": 1416,
	"./dma.svg": 1417,
	"./eng.svg": 1418,
	"./fij.svg": 1419,
	"./flk.svg": 1420,
	"./gab.svg": 1421,
	"./gam.svg": 1422,
	"./ggy.svg": 1423,
	"./gha.svg": 1424,
	"./gib.svg": 1425,
	"./grn.svg": 1426,
	"./guy.svg": 1427,
	"./ind.svg": 1428,
	"./iom.svg": 1429,
	"./ivb.svg": 1430,
	"./jam.svg": 1431,
	"./jey.svg": 1432,
	"./ken.svg": 1433,
	"./kir.svg": 1434,
	"./lca.svg": 1435,
	"./les.svg": 1436,
	"./manifest.json": 791,
	"./mas.svg": 1437,
	"./maw.svg": 1438,
	"./mdv.svg": 1439,
	"./mlt.svg": 1440,
	"./moz.svg": 1441,
	"./mri.svg": 1442,
	"./msr.svg": 1443,
	"./nam.svg": 1444,
	"./nfk.svg": 1445,
	"./ngr.svg": 1446,
	"./nir.svg": 1447,
	"./niu.svg": 1448,
	"./nru.svg": 1449,
	"./nzl.svg": 1450,
	"./pak.svg": 1451,
	"./png.svg": 1452,
	"./rsa.svg": 1453,
	"./rwa.svg": 1454,
	"./sam.svg": 1455,
	"./sco.svg": 1456,
	"./sey.svg": 1457,
	"./sgp.svg": 1458,
	"./shn.svg": 1459,
	"./skn.svg": 1460,
	"./sle.svg": 1461,
	"./sol.svg": 1462,
	"./sri.svg": 1463,
	"./svg-country.svg": 1464,
	"./swz.svg": 1465,
	"./tan.svg": 1466,
	"./tca.svg": 1467,
	"./tga.svg": 1468,
	"./tog.svg": 1469,
	"./tto.svg": 1470,
	"./tuv.svg": 1471,
	"./uga.svg": 1472,
	"./van.svg": 1473,
	"./wal.svg": 1474,
	"./zam.svg": 1475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1401;